import { z } from "zod/v4";

export const legalVersionSchema = z.int().min(1).max(2147483647);
